import { FC, useMemo, useCallback, useEffect } from 'react'

import { List, Pagination, EmptyList, SafetyCaseActionCard } from '../../../components'
import { ISafetyCaseAction, IActionOption } from '../../../interfaces'

type SafetyCaseActionsCardsListProps = {
  pagination: { pageSize: number; pageIndex: number }
  setPagination: (values: { [key: string]: number }) => void
  safetyCaseActions: ISafetyCaseAction[] | undefined
  actionsButtonOptions?: IActionOption<ISafetyCaseAction>[]
  isLoading: boolean
}

const SafetyCaseActionsCardsList: FC<SafetyCaseActionsCardsListProps> = props => {
  const { safetyCaseActions, pagination, setPagination, actionsButtonOptions, isLoading } = props

  const totalItemsCount = safetyCaseActions?.length || 0

  const { pageIndex, pageSize } = pagination

  const setPageSize = useCallback((pageSize: number) => setPagination({ pageSize }), [setPagination])

  const setPageIndex = useCallback((pageIndex: number) => setPagination({ pageIndex }), [setPagination])

  const totalPageCount = useMemo(() => Math.ceil(totalItemsCount / pageSize), [totalItemsCount, pageSize])

  const safetyCaseActionsPage = useMemo(
    () => (safetyCaseActions || []).slice(pageIndex * pageSize, pageIndex * pageSize + pageSize),
    [safetyCaseActions, pageIndex, pageSize],
  )

  useEffect(() => {
    if (pageIndex > totalPageCount) {
      setPageIndex(totalPageCount)
    }
  }, [pageIndex, setPageIndex, totalPageCount])

  const canNextPage = pageIndex < totalPageCount

  const canPreviousPage = pageIndex > 0

  return (
    <>
      <div className="overflow-auto h-100">
        <List
          data={safetyCaseActionsPage}
          ListItem={SafetyCaseActionCard}
          noDataContent={<EmptyList>No Safety Case Actions found.</EmptyList>}
          actionsButtonOptions={actionsButtonOptions}
          isLoading={isLoading}
        />
      </div>

      <Pagination
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalItemsCount={totalItemsCount}
        totalPageCount={totalPageCount}
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
      />
    </>
  )
}

export default SafetyCaseActionsCardsList
